import { queryOptions, useQuery } from '@tanstack/react-query';

import { dictionaryApi } from '../api/dictionary-api';

import { dictionaryKeys } from './dictionary-keys';

/** The organization's attribute dictionary changes rarely; keep it fresh for a few minutes. */
export function attributesQueryOptions() {
  return queryOptions({
    queryKey: dictionaryKeys.attributes(),
    queryFn: dictionaryApi.listAttributes,
    staleTime: 5 * 60_000,
  });
}

export function useAttributes() {
  return useQuery(attributesQueryOptions());
}
